// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.order-item-status-tip.el-tooltip__popper {\r\n  padding: 12px;\r\n  border-color: #ebeef5;\r\n  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\r\n", ""]);
// Exports
module.exports = exports;
